const ScoreBar = ({ n, m = 3, className }) => {
  return (
    <div
      className={
        "flex space-x-1 w-full justify-start items-center " + { className }
      }>
      {Array(m)
        .fill()
        .map((_, index) => {
          let style =
            "w-[10px] h-[10px] rounded-full border border-stone-700" +
            (index < n ? " bg-stone-700" : " opacity-20 bg-none");
          return <div key={index} className={style}></div>;
        })}
    </div>
  );
};

export default ScoreBar;
